import { render, staticRenderFns } from "./login-change-password.vue?vue&type=template&id=7a761a39&scoped=true&"
import script from "./login-change-password.vue?vue&type=script&lang=ts&"
export * from "./login-change-password.vue?vue&type=script&lang=ts&"
import style0 from "./login-change-password.vue?vue&type=style&index=0&id=7a761a39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a761a39",
  null
  
)

export default component.exports